import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Icon } from "components/common";
import { DropdownMenu } from "security-app/components/common";
import DateFilter from "views/components/widgets/overview-configuration/filters/DateFilter";
import ColumnFilterOptions from "./ColumnFilterOptions";
const FilterTrigger = styled.span(
  ({ $open, theme }) => css`
    cursor: pointer;
    position: relative;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
    vertical-align: middle;
    color: ${theme.colors.text.primary};

    & > svg {
      transition: rotate 0.2s;
      rotate: ${$open ? 180 : 0}deg;
    }
  `
);
const ColumnFilter = ({
  filterBy,
  filterData = [],
  loadOptions = void 0,
  loadOptionsKey = "",
  appliedFilters,
  type,
  onClose,
  children
}) => {
  const [open, setOpen] = useState(false);
  const appliedToColumn = appliedFilters[filterBy];
  const [filterValues, setFilterValues] = useState(appliedToColumn || []);
  const [syncedWith, setSyncedWith] = useState(appliedToColumn);
  if (syncedWith !== appliedToColumn) {
    setSyncedWith(appliedToColumn);
    setFilterValues(appliedToColumn || []);
  }
  const closeMenu = () => {
    onClose(filterBy, filterValues.length > 0 ? filterValues : null);
  };
  const filterIncluded = (fData) => !!filterValues.find(({ value }) => value === fData.value);
  const onFilterChange = (fData) => () => {
    if (filterIncluded(fData)) {
      setFilterValues(filterValues.filter(({ value }) => value !== fData.value));
    } else {
      setFilterValues([...filterValues, fData]);
    }
  };
  const onFilterDateChange = (values) => {
    setFilterValues(
      values.map((value) => {
        var _a;
        return {
          label: value,
          value,
          type: "string",
          backend: filterData ? (_a = filterData[0]) == null ? void 0 : _a.backend : void 0
        };
      })
    );
  };
  const filterByType = () => {
    switch (type) {
      case "date":
        return /* @__PURE__ */ React.createElement(DateFilter, { values: filterValues.map(({ value }) => value), onChange: onFilterDateChange });
      default:
        return /* @__PURE__ */ React.createElement(
          ColumnFilterOptions,
          {
            filterBy,
            filterData,
            loadOptions,
            loadOptionsKey,
            isSelected: filterIncluded,
            onToggle: onFilterChange
          }
        );
    }
  };
  const showFilters = type === "date" || !!loadOptions || filterData.length > 1;
  return showFilters ? /* @__PURE__ */ React.createElement(
    DropdownMenu,
    {
      onClose: closeMenu,
      closeOnItemClick: false,
      trigger: /* @__PURE__ */ React.createElement(FilterTrigger, { $open: open, onClick: () => setOpen(!open) }, /* @__PURE__ */ React.createElement(Icon, { name: "keyboard_arrow_down", size: "xs" }), children)
    },
    filterByType()
  ) : /* @__PURE__ */ React.createElement("span", null, children);
};
export default ColumnFilter;
